import "core-js/modules/es.array.push.js";
import { Image, Divider, Button } from 'vant';
export default {
  name: 'NotFound',
  components: {
    Image,
    Divider,
    Button
  },
  methods: {
    goBack() {
      this.$router.push('/');
    }
  }
};